import { render, staticRenderFns } from "./hint.vue?vue&type=template&id=663c252a&"
import script from "./hint.vue?vue&type=script&lang=js&"
export * from "./hint.vue?vue&type=script&lang=js&"
import style0 from "./hint.vue?vue&type=style&index=0&id=663c252a&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports